module.exports = __webpack_public_path__ + "img/services-img2.14892bd0.jpg";